import { render, staticRenderFns } from "./AboutSection.vue?vue&type=template&id=18e7199a&"
import script from "./AboutSection.vue?vue&type=script&lang=js&"
export * from "./AboutSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports